import axios from "lib/axios";

export const cartPurchaseInvoiceApi = async ({ request_token, payment_method_id, payment_token }) => {
  return await axios.post(`/resident_payments/cart/invoice/${request_token}/purchase`, {
    payment_method_id,
    payment_token,
  });
};
